import type { IconData } from "@loot-os/icons/types";
import type { ReactNode } from "react";
import { tv } from "../foundations/cn.js";
import { Icon } from "./Icon.js";

const badgeStyles = tv({
  base: "inline-flex items-center gap-1 rounded-pill px-2 py-0.5 font-body text-caption-eyebrow uppercase",
  variants: {
    tone: {
      neutral: "bg-bg-raised text-text-secondary",
      accent: "bg-accent-subtle text-accent-text",
      success: "bg-status-success-subtle text-status-success",
      warning: "bg-status-warning-subtle text-status-warning",
      danger: "bg-status-danger-subtle text-status-danger",
      /** A solid fill for one thing that must stand out: NEW, LIVE. */
      solid: "bg-accent-default text-text-on-accent",
    },
  },
  defaultVariants: { tone: "neutral" },
});

export interface BadgeProps {
  tone?: NonNullable<Parameters<typeof badgeStyles>[0]>["tone"];
  icon?: IconData;
  children: ReactNode;
  className?: string;
}

/** A short status or label on something else: NEW, LIVE, SOLD OUT, Pending. */
export function Badge({ tone, icon, children, className }: BadgeProps) {
  return (
    <span className={badgeStyles({ tone, className })}>
      {icon && <Icon icon={icon} size={12} />}
      {children}
    </span>
  );
}
